import React from "react";

import { FormInputText, FormInputSelect, FormInputPassword, FormCheckBox, FormInputTextArea, FormTitleSection, FormSubTitleSection, FormButton, FormInputFile, FormInfo, FormInfoLink, FormInfoAlert, FormDownloadFile } from "../Forms";


export const FormInputType = props => {
  if (props.type === 'text') return <FormInputText {...props} />
  else if (props.type === 'textarea') return <FormInputTextArea {...props} />
  else if (props.type === 'select') return <FormInputSelect {...props} />
  else if (props.type === 'password') return <FormInputPassword {...props} />
  else if (props.type === 'checkbox') return <FormCheckBox {...props} />
  else if (props.type === 'section') return <FormTitleSection {...props} />
  else if (props.type === 'subsection') return <FormSubTitleSection {...props} />
  else if (props.type === 'file') return <FormInputFile {...props} />
  else if (props.type === 'info') return <FormInfo {...props} />
  else if (props.type === 'infoalert') return <FormInfoAlert {...props} />
  else if (props.type === 'download') return <FormDownloadFile {...props} />
  else if (props.type === 'infolink') return <FormInfoLink {...props} />
  else if (props.type === 'button') return <FormButton {...props} />
}
